import {ProductReviewPage as NorthAmericaProductReview} from '@/features/ProductReview/ProductReviewPage'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {NEW_THEME_FEATURE_COUNTRIES} from '@/utils/constants/marketFeatureCountries'
import {useSelector} from 'react-redux'
import ProductReview from './ProductReview'

const ProductReviewByMarket = () => {
  const countryCode = useSelector(selectCountryCode)

  if (NEW_THEME_FEATURE_COUNTRIES.includes(countryCode)) {
    return <NorthAmericaProductReview />
  }

  return <ProductReview />
}

export default ProductReviewByMarket
